import script from "./StockReportView.vue?vue&type=script&setup=true&lang=js"
export * from "./StockReportView.vue?vue&type=script&setup=true&lang=js"

import "./StockReportView.vue?vue&type=style&index=0&id=3a49456e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a49456e"]])

export default __exports__